// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#1d2458","paragraphColor":"#232323"};